export const FUEL_MS_URL = process.env.REACT_APP_FUEL_MS_URL;
export const CRYPTO_KEY = process.env.REACT_APP_CRYPTO_KEY;

export const DATA = [
  {
    id: "f867a770-aecf-11ee-a421-8757fbc5e479",
    owner: {
      id: "a9fa77a0-ae68-11ee-a421-8757fbc5e470",
      name: "Mary Donkor",
      phone: "+233507064001",
      user_id: 606,
      last_name: "Donkor",
      first_name: "Mary",
      external_id: "3a2a98fc-abd4-11ee-a9fb-42010a8400b4",
    },
    price: 1.5,
    status: {
      id: "ef8311ed-a10a-7328-bffd-0a0d87edb419",
      code: "USED",
      name: "Used",
      color: "red",
    },
    company: {
      id: "81f2ff10-253e-11ee-8117-67c8758601ee",
      code: "VIVO",
      name: "Shell",
      image_url:
        "https://storage.googleapis.com/oya-file-upload-test/ce829ec0-5c2b-11ee-a52f-d32cbeb14ac1.png",
    },
    creator: {
      id: "07cb25b0-71b4-11ee-b323-e9b94074417e",
      name: "Emmanuel Amoako",
      phone: "+233553554911",
      user_id: 466,
      last_name: "Amoako",
      first_name: "Emmanuel",
      external_id: "e7514776-14f7-11ee-9ad7-42010a840031",
    },
    updater: {
      id: "07cb25b0-71b4-11ee-b323-e9b94074417e",
      name: "Emmanuel Amoako",
      phone: "+233553554911",
      user_id: 466,
      last_name: "Amoako",
      first_name: "Emmanuel",
      external_id: "e7514776-14f7-11ee-9ad7-42010a840031",
    },
    currency: "GHS",
    fuel_type: {
      code: "DIESEL",
      name: "Diesel",
    },
    reference: "8353579709",
    created_at: "2024-01-09T09:17:54Z",
    owner_type: {
      code: "ANOTHER",
      name: "Another",
    },
    updated_at: "2024-01-09T09:18:12Z",
    amount_left: 1.5,
    amount_used: 0,
    coupon_image:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 49" shape-rendering="crispEdges"><path fill="#ffffff" d="M0 0h49v49H0z"/><path stroke="#000000" d="M4 4.5h7m1 0h1m2 0h1m1 0h2m4 0h1m1 0h2m1 0h2m1 0h1m1 0h1m2 0h1m1 0h7M4 5.5h1m5 0h1m1 0h1m4 0h2m2 0h1m2 0h1m3 0h1m3 0h1m2 0h2m1 0h1m5 0h1M4 6.5h1m1 0h3m1 0h1m1 0h2m1 0h1m1 0h1m1 0h4m1 0h2m1 0h2m1 0h1m1 0h1m5 0h1m1 0h3m1 0h1M4 7.5h1m1 0h3m1 0h1m5 0h2m6 0h1m1 0h1m1 0h1m4 0h1m4 0h1m1 0h3m1 0h1M4 8.5h1m1 0h3m1 0h1m1 0h2m1 0h1m1 0h1m2 0h7m7 0h3m1 0h1m1 0h3m1 0h1M4 9.5h1m5 0h1m2 0h1m2 0h2m2 0h2m3 0h1m1 0h1m1 0h2m2 0h2m3 0h1m5 0h1M4 10.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M15 11.5h3m1 0h1m4 0h1m1 0h1m2 0h2m1 0h1m3 0h1M4 12.5h1m2 0h8m1 0h4m1 0h1m1 0h1m2 0h1m4 0h3m1 0h1m1 0h1m2 0h1m1 0h3M4 13.5h1m2 0h2m3 0h1m2 0h2m2 0h1m1 0h3m3 0h2m2 0h1m2 0h1m4 0h2m2 0h2M4 14.5h5m1 0h2m2 0h2m3 0h1m1 0h1m3 0h3m1 0h1m1 0h1m1 0h2m1 0h1m3 0h2m1 0h2M4 15.5h1m1 0h1m1 0h1m2 0h9m1 0h2m4 0h2m1 0h4m1 0h2m3 0h1m2 0h1M5 16.5h2m1 0h1m1 0h2m2 0h2m3 0h1m2 0h2m2 0h3m2 0h2m1 0h1m1 0h1m1 0h2m1 0h1m2 0h1M7 17.5h1m1 0h1m1 0h3m2 0h2m4 0h3m1 0h1m3 0h2m1 0h2m1 0h2m2 0h3m1 0h1M4 18.5h3m1 0h4m1 0h2m1 0h1m3 0h2m1 0h2m1 0h4m1 0h5m2 0h3m3 0h1M5 19.5h1m2 0h1m3 0h3m1 0h1m1 0h3m3 0h4m3 0h2m1 0h7m1 0h3M5 20.5h8m2 0h5m1 0h2m2 0h2m2 0h1m1 0h1m2 0h1m1 0h1m4 0h1M5 21.5h5m1 0h3m2 0h2m3 0h6m3 0h1m2 0h3m1 0h1m2 0h2m1 0h1M9 22.5h2m3 0h2m2 0h2m1 0h2m1 0h1m2 0h1m1 0h3m1 0h1m1 0h1m5 0h1m1 0h2M11 23.5h3m1 0h3m1 0h1m5 0h1m2 0h4m1 0h3m1 0h1m1 0h1m2 0h2M4 24.5h1m5 0h1m1 0h1m4 0h2m3 0h2m1 0h1m3 0h1m4 0h3m1 0h1m1 0h3M4 25.5h3m5 0h3m1 0h1m3 0h1m2 0h2m1 0h7m2 0h2m2 0h5M5 26.5h1m2 0h1m1 0h1m2 0h1m1 0h3m1 0h1m2 0h1m1 0h1m1 0h2m2 0h4m2 0h1m1 0h2m2 0h1M4 27.5h1m1 0h1m2 0h1m2 0h2m1 0h2m1 0h1m1 0h2m6 0h1m2 0h1m1 0h2m1 0h1m3 0h1m3 0h1M5 28.5h1m3 0h2m3 0h1m8 0h2m1 0h3m1 0h3m1 0h3m1 0h2m3 0h2M4 29.5h5m5 0h1m1 0h2m1 0h1m2 0h1m3 0h2m1 0h1m1 0h1m1 0h2m3 0h5m1 0h1M4 30.5h4m2 0h1m1 0h2m2 0h1m3 0h6m4 0h3m2 0h4m2 0h2M4 31.5h4m1 0h1m1 0h3m4 0h1m3 0h1m3 0h2m2 0h3m2 0h1m4 0h3M4 32.5h1m2 0h1m2 0h3m3 0h2m2 0h1m2 0h2m2 0h1m1 0h1m2 0h1m1 0h4m1 0h1M4 33.5h1m1 0h1m1 0h1m2 0h5m1 0h2m2 0h1m2 0h1m2 0h3m1 0h1m1 0h1m1 0h1m4 0h1M4 34.5h2m2 0h6m1 0h2m1 0h3m3 0h1m1 0h2m1 0h1m2 0h1m1 0h1m2 0h2m1 0h1m1 0h1m1 0h1M4 35.5h2m2 0h1m3 0h1m1 0h2m3 0h1m2 0h1m5 0h1m1 0h1m1 0h1m1 0h1m1 0h1m2 0h2m1 0h1m1 0h1M4 36.5h4m1 0h2m2 0h5m1 0h1m2 0h1m1 0h1m1 0h1m1 0h1m2 0h2m1 0h11M12 37.5h4m5 0h1m1 0h2m1 0h1m2 0h4m3 0h1m3 0h3M4 38.5h7m1 0h3m3 0h1m1 0h1m3 0h2m1 0h1m1 0h1m1 0h1m1 0h1m1 0h2m1 0h1m1 0h4M4 39.5h1m5 0h1m1 0h2m5 0h1m2 0h3m2 0h3m2 0h2m1 0h2m3 0h2M4 40.5h1m1 0h3m1 0h1m1 0h1m3 0h2m1 0h3m1 0h1m1 0h2m1 0h2m1 0h1m3 0h6m3 0h1M4 41.5h1m1 0h3m1 0h1m1 0h1m3 0h3m1 0h1m1 0h1m1 0h1m1 0h2m1 0h3m2 0h1m2 0h1m4 0h1M4 42.5h1m1 0h3m1 0h1m2 0h1m1 0h1m1 0h1m1 0h2m1 0h5m1 0h1m1 0h6m1 0h1m1 0h4m1 0h1M4 43.5h1m5 0h1m2 0h1m1 0h3m2 0h1m2 0h1m2 0h3m1 0h1m1 0h1m1 0h2m2 0h2m1 0h1m2 0h1M4 44.5h7m1 0h2m2 0h1m2 0h1m2 0h1m1 0h1m2 0h1m1 0h2m1 0h1m1 0h1m1 0h1m2 0h3"/></svg>\n',
    payment_status: {
      id: "e7ab11ed-1e71-7e79-bffd-0a0d87edb419",
      code: "COMPLETED",
      name: "Paid",
    },
  },
  {
    id: "f867a770-aecf-11ee-a421-8757fbc5e470",
    owner: {
      id: "a9fa77a0-ae68-11ee-a421-8757fbc5e470",
      name: "Mary Donkor",
      phone: "+233507064001",
      user_id: 606,
      last_name: "Donkor",
      first_name: "Mary",
      external_id: "3a2a98fc-abd4-11ee-a9fb-42010a8400b4",
    },
    price: 1.5,
    status: {
      id: "ef8311ed-a10a-7328-bffd-0a0d87edb419",
      code: "NOT_USED",
      name: "Not Used",
      color: "red",
    },
    company: {
      id: "81f2ff10-253e-11ee-8117-67c8758601ee",
      code: "VIVO",
      name: "Shell",
      image_url:
        "https://storage.googleapis.com/oya-file-upload-test/ce829ec0-5c2b-11ee-a52f-d32cbeb14ac1.png",
    },
    creator: {
      id: "07cb25b0-71b4-11ee-b323-e9b94074417e",
      name: "Emmanuel Amoako",
      phone: "+233553554911",
      user_id: 466,
      last_name: "Amoako",
      first_name: "Emmanuel",
      external_id: "e7514776-14f7-11ee-9ad7-42010a840031",
    },
    updater: {
      id: "07cb25b0-71b4-11ee-b323-e9b94074417e",
      name: "Emmanuel Amoako",
      phone: "+233553554911",
      user_id: 466,
      last_name: "Amoako",
      first_name: "Emmanuel",
      external_id: "e7514776-14f7-11ee-9ad7-42010a840031",
    },
    currency: "GHS",
    fuel_type: {
      code: "DIESEL",
      name: "Diesel",
    },
    reference: "8353579709",
    created_at: "2024-01-09T09:17:54Z",
    owner_type: {
      code: "ANOTHER",
      name: "Another",
    },
    updated_at: "2024-01-09T09:18:12Z",
    amount_left: 1.5,
    amount_used: 0,
    coupon_image:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 49" shape-rendering="crispEdges"><path fill="#ffffff" d="M0 0h49v49H0z"/><path stroke="#000000" d="M4 4.5h7m1 0h1m2 0h1m1 0h2m4 0h1m1 0h2m1 0h2m1 0h1m1 0h1m2 0h1m1 0h7M4 5.5h1m5 0h1m1 0h1m4 0h2m2 0h1m2 0h1m3 0h1m3 0h1m2 0h2m1 0h1m5 0h1M4 6.5h1m1 0h3m1 0h1m1 0h2m1 0h1m1 0h1m1 0h4m1 0h2m1 0h2m1 0h1m1 0h1m5 0h1m1 0h3m1 0h1M4 7.5h1m1 0h3m1 0h1m5 0h2m6 0h1m1 0h1m1 0h1m4 0h1m4 0h1m1 0h3m1 0h1M4 8.5h1m1 0h3m1 0h1m1 0h2m1 0h1m1 0h1m2 0h7m7 0h3m1 0h1m1 0h3m1 0h1M4 9.5h1m5 0h1m2 0h1m2 0h2m2 0h2m3 0h1m1 0h1m1 0h2m2 0h2m3 0h1m5 0h1M4 10.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M15 11.5h3m1 0h1m4 0h1m1 0h1m2 0h2m1 0h1m3 0h1M4 12.5h1m2 0h8m1 0h4m1 0h1m1 0h1m2 0h1m4 0h3m1 0h1m1 0h1m2 0h1m1 0h3M4 13.5h1m2 0h2m3 0h1m2 0h2m2 0h1m1 0h3m3 0h2m2 0h1m2 0h1m4 0h2m2 0h2M4 14.5h5m1 0h2m2 0h2m3 0h1m1 0h1m3 0h3m1 0h1m1 0h1m1 0h2m1 0h1m3 0h2m1 0h2M4 15.5h1m1 0h1m1 0h1m2 0h9m1 0h2m4 0h2m1 0h4m1 0h2m3 0h1m2 0h1M5 16.5h2m1 0h1m1 0h2m2 0h2m3 0h1m2 0h2m2 0h3m2 0h2m1 0h1m1 0h1m1 0h2m1 0h1m2 0h1M7 17.5h1m1 0h1m1 0h3m2 0h2m4 0h3m1 0h1m3 0h2m1 0h2m1 0h2m2 0h3m1 0h1M4 18.5h3m1 0h4m1 0h2m1 0h1m3 0h2m1 0h2m1 0h4m1 0h5m2 0h3m3 0h1M5 19.5h1m2 0h1m3 0h3m1 0h1m1 0h3m3 0h4m3 0h2m1 0h7m1 0h3M5 20.5h8m2 0h5m1 0h2m2 0h2m2 0h1m1 0h1m2 0h1m1 0h1m4 0h1M5 21.5h5m1 0h3m2 0h2m3 0h6m3 0h1m2 0h3m1 0h1m2 0h2m1 0h1M9 22.5h2m3 0h2m2 0h2m1 0h2m1 0h1m2 0h1m1 0h3m1 0h1m1 0h1m5 0h1m1 0h2M11 23.5h3m1 0h3m1 0h1m5 0h1m2 0h4m1 0h3m1 0h1m1 0h1m2 0h2M4 24.5h1m5 0h1m1 0h1m4 0h2m3 0h2m1 0h1m3 0h1m4 0h3m1 0h1m1 0h3M4 25.5h3m5 0h3m1 0h1m3 0h1m2 0h2m1 0h7m2 0h2m2 0h5M5 26.5h1m2 0h1m1 0h1m2 0h1m1 0h3m1 0h1m2 0h1m1 0h1m1 0h2m2 0h4m2 0h1m1 0h2m2 0h1M4 27.5h1m1 0h1m2 0h1m2 0h2m1 0h2m1 0h1m1 0h2m6 0h1m2 0h1m1 0h2m1 0h1m3 0h1m3 0h1M5 28.5h1m3 0h2m3 0h1m8 0h2m1 0h3m1 0h3m1 0h3m1 0h2m3 0h2M4 29.5h5m5 0h1m1 0h2m1 0h1m2 0h1m3 0h2m1 0h1m1 0h1m1 0h2m3 0h5m1 0h1M4 30.5h4m2 0h1m1 0h2m2 0h1m3 0h6m4 0h3m2 0h4m2 0h2M4 31.5h4m1 0h1m1 0h3m4 0h1m3 0h1m3 0h2m2 0h3m2 0h1m4 0h3M4 32.5h1m2 0h1m2 0h3m3 0h2m2 0h1m2 0h2m2 0h1m1 0h1m2 0h1m1 0h4m1 0h1M4 33.5h1m1 0h1m1 0h1m2 0h5m1 0h2m2 0h1m2 0h1m2 0h3m1 0h1m1 0h1m1 0h1m4 0h1M4 34.5h2m2 0h6m1 0h2m1 0h3m3 0h1m1 0h2m1 0h1m2 0h1m1 0h1m2 0h2m1 0h1m1 0h1m1 0h1M4 35.5h2m2 0h1m3 0h1m1 0h2m3 0h1m2 0h1m5 0h1m1 0h1m1 0h1m1 0h1m1 0h1m2 0h2m1 0h1m1 0h1M4 36.5h4m1 0h2m2 0h5m1 0h1m2 0h1m1 0h1m1 0h1m1 0h1m2 0h2m1 0h11M12 37.5h4m5 0h1m1 0h2m1 0h1m2 0h4m3 0h1m3 0h3M4 38.5h7m1 0h3m3 0h1m1 0h1m3 0h2m1 0h1m1 0h1m1 0h1m1 0h1m1 0h2m1 0h1m1 0h4M4 39.5h1m5 0h1m1 0h2m5 0h1m2 0h3m2 0h3m2 0h2m1 0h2m3 0h2M4 40.5h1m1 0h3m1 0h1m1 0h1m3 0h2m1 0h3m1 0h1m1 0h2m1 0h2m1 0h1m3 0h6m3 0h1M4 41.5h1m1 0h3m1 0h1m1 0h1m3 0h3m1 0h1m1 0h1m1 0h1m1 0h2m1 0h3m2 0h1m2 0h1m4 0h1M4 42.5h1m1 0h3m1 0h1m2 0h1m1 0h1m1 0h1m1 0h2m1 0h5m1 0h1m1 0h6m1 0h1m1 0h4m1 0h1M4 43.5h1m5 0h1m2 0h1m1 0h3m2 0h1m2 0h1m2 0h3m1 0h1m1 0h1m1 0h2m2 0h2m1 0h1m2 0h1M4 44.5h7m1 0h2m2 0h1m2 0h1m2 0h1m1 0h1m2 0h1m1 0h2m1 0h1m1 0h1m1 0h1m2 0h3"/></svg>\n',
    payment_status: {
      id: "e7ab11ed-1e71-7e79-bffd-0a0d87edb419",
      code: "COMPLETED",
      name: "Paid",
    },
  },
  {
    id: "b7599cf0-aeae-11ee-a421-8757fbc5e470",
    owner: {
      id: "a9fa77a0-ae68-11ee-a421-8757fbc5e470",
      name: "Mary Donkor",
      phone: "+233507064001",
      user_id: 606,
      last_name: "Donkor",
      first_name: "Mary",
      external_id: "3a2a98fc-abd4-11ee-a9fb-42010a8400b4",
    },
    price: 1.5,
    status: {
      id: "ef8311ed-a10a-7328-bffd-0a0d87edb419",
      code: "NOT_USED",
      name: "Not Used",
      color: "red",
    },
    company: {
      id: "81f2ff10-253e-11ee-8117-67c8758601ee",
      code: "VIVO",
      name: "Shell",
      image_url:
        "https://storage.googleapis.com/oya-file-upload-test/ce829ec0-5c2b-11ee-a52f-d32cbeb14ac1.png",
    },
    creator: {
      id: "07cb25b0-71b4-11ee-b323-e9b94074417e",
      name: "Emmanuel Amoako",
      phone: "+233553554911",
      user_id: 466,
      last_name: "Amoako",
      first_name: "Emmanuel",
      external_id: "e7514776-14f7-11ee-9ad7-42010a840031",
    },
    updater: {
      id: "07cb25b0-71b4-11ee-b323-e9b94074417e",
      name: "Emmanuel Amoako",
      phone: "+233553554911",
      user_id: 466,
      last_name: "Amoako",
      first_name: "Emmanuel",
      external_id: "e7514776-14f7-11ee-9ad7-42010a840031",
    },
    currency: "GHS",
    fuel_type: {
      code: "DIESEL",
      name: "Diesel",
    },
    reference: "8766619599",
    created_at: "2024-01-09T05:19:52Z",
    owner_type: {
      code: "ANOTHER",
      name: "Another",
    },
    updated_at: "2024-01-09T05:19:52Z",
    amount_left: 1.5,
    amount_used: 0,
    coupon_image:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 49" shape-rendering="crispEdges"><path fill="#ffffff" d="M0 0h49v49H0z"/><path stroke="#000000" d="M4 4.5h7m1 0h1m4 0h1m2 0h1m2 0h1m1 0h2m1 0h3m1 0h2m2 0h1m1 0h7M4 5.5h1m5 0h1m1 0h1m2 0h1m1 0h5m2 0h1m3 0h1m2 0h1m3 0h2m1 0h1m5 0h1M4 6.5h1m1 0h3m1 0h1m1 0h2m3 0h1m1 0h1m1 0h2m1 0h2m1 0h2m1 0h2m6 0h1m1 0h3m1 0h1M4 7.5h1m1 0h3m1 0h1m4 0h1m1 0h1m1 0h1m4 0h1m1 0h1m1 0h1m2 0h1m1 0h1m4 0h1m1 0h3m1 0h1M4 8.5h1m1 0h3m1 0h1m1 0h1m2 0h1m3 0h8m7 0h3m1 0h1m1 0h3m1 0h1M4 9.5h1m5 0h1m2 0h3m2 0h4m3 0h3m1 0h1m3 0h2m3 0h1m5 0h1M4 10.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M16 11.5h2m6 0h1m1 0h1m2 0h2m1 0h1m3 0h1M4 12.5h1m2 0h10m1 0h2m1 0h1m1 0h1m4 0h1m2 0h3m1 0h1m1 0h1m2 0h1m1 0h3M4 13.5h3m1 0h2m1 0h2m1 0h1m4 0h1m1 0h3m2 0h2m3 0h1m2 0h1m4 0h2m2 0h2M4 14.5h3m1 0h1m1 0h1m1 0h2m2 0h1m1 0h2m1 0h1m3 0h3m1 0h1m1 0h1m1 0h2m1 0h1m3 0h2m1 0h2M4 15.5h1m2 0h2m3 0h1m3 0h1m1 0h1m1 0h3m4 0h2m1 0h4m1 0h2m3 0h1m2 0h1M5 16.5h4m1 0h2m1 0h2m2 0h2m3 0h2m2 0h1m1 0h1m2 0h2m1 0h1m1 0h1m1 0h2m1 0h1m2 0h1M7 17.5h1m1 0h1m2 0h1m1 0h1m1 0h1m1 0h1m3 0h3m1 0h1m2 0h3m1 0h2m1 0h2m2 0h3m1 0h1M5 18.5h3m1 0h2m1 0h2m2 0h1m3 0h2m1 0h2m1 0h10m2 0h3m3 0h1M6 19.5h4m2 0h1m1 0h1m1 0h5m3 0h4m3 0h2m1 0h7m1 0h3M4 20.5h1m1 0h2m2 0h2m1 0h4m2 0h4m2 0h2m2 0h1m1 0h1m2 0h1m1 0h1m4 0h1M5 21.5h1m5 0h4m2 0h1m3 0h6m3 0h2m1 0h3m1 0h1m2 0h2m1 0h1M8 22.5h1m1 0h1m3 0h1m3 0h5m1 0h1m2 0h1m1 0h3m1 0h1m1 0h1m5 0h1m1 0h2M4 23.5h1m3 0h2m2 0h2m1 0h3m2 0h1m4 0h1m2 0h4m1 0h3m1 0h1m1 0h1m2 0h2M9 24.5h2m1 0h1m2 0h5m2 0h2m1 0h1m3 0h1m4 0h3m1 0h1m1 0h3M6 25.5h1m1 0h1m3 0h1m1 0h2m1 0h1m1 0h2m2 0h2m1 0h3m1 0h3m2 0h2m2 0h5M5 26.5h1m2 0h3m3 0h1m2 0h1m1 0h1m1 0h2m1 0h1m1 0h2m1 0h1m1 0h3m2 0h1m1 0h2m2 0h1M6 27.5h1m1 0h2m2 0h3m1 0h1m2 0h3m4 0h1m1 0h1m1 0h2m1 0h2m1 0h1m3 0h1m3 0h1M8 28.5h1m1 0h1m8 0h1m3 0h2m1 0h2m2 0h3m1 0h3m1 0h2m3 0h2M4 29.5h1m1 0h1m1 0h2m1 0h1m1 0h1m1 0h2m2 0h2m1 0h1m3 0h4m1 0h1m1 0h2m3 0h5m1 0h1M4 30.5h2m1 0h1m2 0h1m1 0h1m1 0h1m2 0h1m3 0h5m4 0h3m2 0h4m2 0h2M4 31.5h2m1 0h1m1 0h1m1 0h1m3 0h1m2 0h3m1 0h1m3 0h1m1 0h1m1 0h3m2 0h1m4 0h3M4 32.5h1m1 0h1m3 0h1m2 0h1m2 0h3m1 0h1m2 0h2m4 0h1m2 0h1m1 0h4m1 0h1M4 33.5h1m1 0h3m3 0h2m1 0h1m1 0h1m3 0h1m2 0h1m2 0h3m1 0h1m1 0h1m1 0h1m4 0h1M4 34.5h2m2 0h1m1 0h2m3 0h6m3 0h1m1 0h2m2 0h1m1 0h1m1 0h1m2 0h2m1 0h1m1 0h1m1 0h1M4 35.5h5m5 0h2m2 0h2m2 0h1m5 0h1m3 0h1m1 0h1m1 0h1m2 0h2m1 0h1m1 0h1M4 36.5h4m1 0h2m1 0h2m1 0h2m2 0h1m2 0h1m1 0h1m1 0h1m1 0h1m1 0h3m1 0h11M12 37.5h2m5 0h3m1 0h2m1 0h1m2 0h1m1 0h2m3 0h1m3 0h3M4 38.5h7m1 0h3m3 0h1m5 0h2m1 0h1m1 0h1m1 0h1m1 0h1m1 0h2m1 0h1m1 0h4M4 39.5h1m5 0h1m1 0h2m1 0h2m2 0h1m2 0h3m2 0h3m2 0h2m1 0h2m3 0h2m1 0h2M4 40.5h1m1 0h3m1 0h1m1 0h1m2 0h3m2 0h2m1 0h1m1 0h2m1 0h2m1 0h1m3 0h6m3 0h1M4 41.5h1m1 0h3m1 0h1m1 0h2m2 0h4m2 0h1m1 0h1m1 0h2m1 0h3m2 0h1m2 0h1m4 0h1M4 42.5h1m1 0h3m1 0h1m2 0h1m1 0h1m2 0h1m1 0h1m2 0h4m1 0h8m1 0h1m1 0h4m1 0h1M4 43.5h1m5 0h1m2 0h1m2 0h3m2 0h3m2 0h3m3 0h1m1 0h2m2 0h2m1 0h1m2 0h1M4 44.5h7m1 0h8m1 0h1m2 0h1m2 0h1m1 0h2m1 0h1m1 0h1m1 0h1m2 0h3"/></svg>\n',
    payment_status: {
      id: "e7ab11ed-9d21-9429-bffd-0a0d87edb419",
      code: "PENDING",
      name: "Not Paid",
    },
  },
  {
    id: "b7599cf0-aeae-11ee-a421-8757fbc5e471",
    owner: {
      id: "a9fa77a0-ae68-11ee-a421-8757fbc5e470",
      name: "Mary Donkor",
      phone: "+233507064001",
      user_id: 606,
      last_name: "Donkor",
      first_name: "Mary",
      external_id: "3a2a98fc-abd4-11ee-a9fb-42010a8400b4",
    },
    price: 210.5,
    status: {
      id: "ef8311ed-a10a-7328-bffd-0a0d87edb419",
      code: "NOT_USED",
      name: "Not Used",
      color: "red",
    },
    company: {
      id: "81f2ff10-253e-11ee-8117-67c8758601ee",
      code: "VIVO",
      name: "Shell",
      image_url:
        "https://storage.googleapis.com/oya-file-upload-test/ce829ec0-5c2b-11ee-a52f-d32cbeb14ac1.png",
    },
    creator: {
      id: "07cb25b0-71b4-11ee-b323-e9b94074417e",
      name: "Emmanuel Amoako",
      phone: "+233553554911",
      user_id: 466,
      last_name: "Amoako",
      first_name: "Emmanuel",
      external_id: "e7514776-14f7-11ee-9ad7-42010a840031",
    },
    updater: {
      id: "07cb25b0-71b4-11ee-b323-e9b94074417e",
      name: "Emmanuel Amoako",
      phone: "+233553554911",
      user_id: 466,
      last_name: "Amoako",
      first_name: "Emmanuel",
      external_id: "e7514776-14f7-11ee-9ad7-42010a840031",
    },
    currency: "GHS",
    fuel_type: {
      code: "DIESEL",
      name: "Diesel",
    },
    reference: "8766619599",
    created_at: "2024-01-09T05:19:52Z",
    owner_type: {
      code: "ANOTHER",
      name: "Another",
    },
    updated_at: "2024-01-09T05:19:52Z",
    amount_left: 1.5,
    amount_used: 0,
    coupon_image:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 49" shape-rendering="crispEdges"><path fill="#ffffff" d="M0 0h49v49H0z"/><path stroke="#000000" d="M4 4.5h7m1 0h1m4 0h1m2 0h1m2 0h1m1 0h2m1 0h3m1 0h2m2 0h1m1 0h7M4 5.5h1m5 0h1m1 0h1m2 0h1m1 0h5m2 0h1m3 0h1m2 0h1m3 0h2m1 0h1m5 0h1M4 6.5h1m1 0h3m1 0h1m1 0h2m3 0h1m1 0h1m1 0h2m1 0h2m1 0h2m1 0h2m6 0h1m1 0h3m1 0h1M4 7.5h1m1 0h3m1 0h1m4 0h1m1 0h1m1 0h1m4 0h1m1 0h1m1 0h1m2 0h1m1 0h1m4 0h1m1 0h3m1 0h1M4 8.5h1m1 0h3m1 0h1m1 0h1m2 0h1m3 0h8m7 0h3m1 0h1m1 0h3m1 0h1M4 9.5h1m5 0h1m2 0h3m2 0h4m3 0h3m1 0h1m3 0h2m3 0h1m5 0h1M4 10.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M16 11.5h2m6 0h1m1 0h1m2 0h2m1 0h1m3 0h1M4 12.5h1m2 0h10m1 0h2m1 0h1m1 0h1m4 0h1m2 0h3m1 0h1m1 0h1m2 0h1m1 0h3M4 13.5h3m1 0h2m1 0h2m1 0h1m4 0h1m1 0h3m2 0h2m3 0h1m2 0h1m4 0h2m2 0h2M4 14.5h3m1 0h1m1 0h1m1 0h2m2 0h1m1 0h2m1 0h1m3 0h3m1 0h1m1 0h1m1 0h2m1 0h1m3 0h2m1 0h2M4 15.5h1m2 0h2m3 0h1m3 0h1m1 0h1m1 0h3m4 0h2m1 0h4m1 0h2m3 0h1m2 0h1M5 16.5h4m1 0h2m1 0h2m2 0h2m3 0h2m2 0h1m1 0h1m2 0h2m1 0h1m1 0h1m1 0h2m1 0h1m2 0h1M7 17.5h1m1 0h1m2 0h1m1 0h1m1 0h1m1 0h1m3 0h3m1 0h1m2 0h3m1 0h2m1 0h2m2 0h3m1 0h1M5 18.5h3m1 0h2m1 0h2m2 0h1m3 0h2m1 0h2m1 0h10m2 0h3m3 0h1M6 19.5h4m2 0h1m1 0h1m1 0h5m3 0h4m3 0h2m1 0h7m1 0h3M4 20.5h1m1 0h2m2 0h2m1 0h4m2 0h4m2 0h2m2 0h1m1 0h1m2 0h1m1 0h1m4 0h1M5 21.5h1m5 0h4m2 0h1m3 0h6m3 0h2m1 0h3m1 0h1m2 0h2m1 0h1M8 22.5h1m1 0h1m3 0h1m3 0h5m1 0h1m2 0h1m1 0h3m1 0h1m1 0h1m5 0h1m1 0h2M4 23.5h1m3 0h2m2 0h2m1 0h3m2 0h1m4 0h1m2 0h4m1 0h3m1 0h1m1 0h1m2 0h2M9 24.5h2m1 0h1m2 0h5m2 0h2m1 0h1m3 0h1m4 0h3m1 0h1m1 0h3M6 25.5h1m1 0h1m3 0h1m1 0h2m1 0h1m1 0h2m2 0h2m1 0h3m1 0h3m2 0h2m2 0h5M5 26.5h1m2 0h3m3 0h1m2 0h1m1 0h1m1 0h2m1 0h1m1 0h2m1 0h1m1 0h3m2 0h1m1 0h2m2 0h1M6 27.5h1m1 0h2m2 0h3m1 0h1m2 0h3m4 0h1m1 0h1m1 0h2m1 0h2m1 0h1m3 0h1m3 0h1M8 28.5h1m1 0h1m8 0h1m3 0h2m1 0h2m2 0h3m1 0h3m1 0h2m3 0h2M4 29.5h1m1 0h1m1 0h2m1 0h1m1 0h1m1 0h2m2 0h2m1 0h1m3 0h4m1 0h1m1 0h2m3 0h5m1 0h1M4 30.5h2m1 0h1m2 0h1m1 0h1m1 0h1m2 0h1m3 0h5m4 0h3m2 0h4m2 0h2M4 31.5h2m1 0h1m1 0h1m1 0h1m3 0h1m2 0h3m1 0h1m3 0h1m1 0h1m1 0h3m2 0h1m4 0h3M4 32.5h1m1 0h1m3 0h1m2 0h1m2 0h3m1 0h1m2 0h2m4 0h1m2 0h1m1 0h4m1 0h1M4 33.5h1m1 0h3m3 0h2m1 0h1m1 0h1m3 0h1m2 0h1m2 0h3m1 0h1m1 0h1m1 0h1m4 0h1M4 34.5h2m2 0h1m1 0h2m3 0h6m3 0h1m1 0h2m2 0h1m1 0h1m1 0h1m2 0h2m1 0h1m1 0h1m1 0h1M4 35.5h5m5 0h2m2 0h2m2 0h1m5 0h1m3 0h1m1 0h1m1 0h1m2 0h2m1 0h1m1 0h1M4 36.5h4m1 0h2m1 0h2m1 0h2m2 0h1m2 0h1m1 0h1m1 0h1m1 0h1m1 0h3m1 0h11M12 37.5h2m5 0h3m1 0h2m1 0h1m2 0h1m1 0h2m3 0h1m3 0h3M4 38.5h7m1 0h3m3 0h1m5 0h2m1 0h1m1 0h1m1 0h1m1 0h1m1 0h2m1 0h1m1 0h4M4 39.5h1m5 0h1m1 0h2m1 0h2m2 0h1m2 0h3m2 0h3m2 0h2m1 0h2m3 0h2m1 0h2M4 40.5h1m1 0h3m1 0h1m1 0h1m2 0h3m2 0h2m1 0h1m1 0h2m1 0h2m1 0h1m3 0h6m3 0h1M4 41.5h1m1 0h3m1 0h1m1 0h2m2 0h4m2 0h1m1 0h1m1 0h2m1 0h3m2 0h1m2 0h1m4 0h1M4 42.5h1m1 0h3m1 0h1m2 0h1m1 0h1m2 0h1m1 0h1m2 0h4m1 0h8m1 0h1m1 0h4m1 0h1M4 43.5h1m5 0h1m2 0h1m2 0h3m2 0h3m2 0h3m3 0h1m1 0h2m2 0h2m1 0h1m2 0h1M4 44.5h7m1 0h8m1 0h1m2 0h1m2 0h1m1 0h2m1 0h1m1 0h1m1 0h1m2 0h3"/></svg>\n',
    payment_status: {
      id: "e7ab11ed-9d21-9429-bffd-0a0d87edb419",
      code: "PENDING",
      name: "Not Paid",
    },
  },
];
